import { Box, Button, Card, CircularProgress, IconButton, Stack, Typography } from "@mui/material"
import { FormBlock } from "../../../../../common/FormGenerator"
import { getDynamicConfig } from "./settingsConfig"
import { CardStyle } from "./style"
import { IconCloseRed } from "../../../../../icons/IconCloseRed"

export type ActionPlanStepCardProps = {
    index: number
    isDraft: boolean
    isSavingDraft: boolean
    onRemove: () => void
    onSaveDraft: () => void
}

export const ActionPlanStepCard = ({
    index,
    isDraft,
    isSavingDraft,
    onRemove,
    onSaveDraft,
}: ActionPlanStepCardProps) => {
    return (
        <Card variant="primaryCard" sx={CardStyle}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="black-16-semiBold">
                    Название шага {index + 1}
                </Typography>
                <IconButton
                    onClick={onRemove}
                    size="small"
                    sx={{ p: 0, my: -0.5, }}
                >
                    <IconCloseRed fontSize="small" />
                </IconButton>
            </Stack>
            <Box mb={1.5}>
                <FormBlock formFieldConfig={getDynamicConfig('actionPlanName', index, "actionPlan")} />
            </Box>
            <Typography
                variant="black-16-semiBold"
                component="div"
                mb={1}
            >
                Даты от и до
            </Typography>
            <Box mb={1.5}>
                <FormBlock
                    formFieldConfig={getDynamicConfig('actionPlanDates', index, "actionPlan")}
                    sx={{
                        display: "flex",
                        gap: 1.5,
                        flexWrap: { xs: "wrap", sm: "nowrap" },
                        "& > div": {
                            flex: 1,
                            minWidth: 0,
                        },
                    }}
                />
            </Box>
            <Typography
                variant="black-16-semiBold"
                component="div"
                mb={1}
            >
                Описание шага
            </Typography>
            <Box mb={1.5}>
                <FormBlock formFieldConfig={getDynamicConfig('actionPlanDescription', index, "actionPlan")} />
            </Box>
            <Typography
                variant="black-16-semiBold"
                component="div"
                mb={1}
            >
                Ответственен
            </Typography>
            <Box mb={1.5}>
                <FormBlock formFieldConfig={getDynamicConfig('actionPlanResponsible', index, "actionPlan")} />
            </Box>
            {isDraft && (
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        type="button"
                        variant="follow"
                        disabled={isSavingDraft}
                        onClick={onSaveDraft}
                    >
                        {isSavingDraft ? (
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <CircularProgress size={16} color="inherit" />
                                <span>Сохранение...</span>
                            </Stack>
                        ) : (
                            "Сохранить шаг"
                        )}
                    </Button>
                </Stack>
            )}
        </Card>
    )
}
